module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.8b8ecc9c.svg";